import { JsonRPCApi } from '@estee/elc-jsonrpc-api';
import { IResponse } from '@estee/elc-http-transport';

const METHOD_TYPE = 'dbgmethod';

export interface IEarlyAccessInfo {
    isSignedIn?: number;
    isLoyaltyMember?: number;
    earlyAccessSkuIds?: number[];
    earlyAccessLoaded?: boolean;
}

export interface IPGResponse {
    error?: {
        data: {
            messages?: { text?: string }[];
        };
    };
    result: {
        data: {
            Analytics?: any;
        };
        value: {
            loyalty_member?: number;
            signed_in?: number;
            sku_ids?: number[];
        };
    };
}

export class EarlyAccessAPI extends JsonRPCApi {

    public isSignedIn : number;
    public isLoyaltyMember : number;
    public earlyAccessSkuIds : number[];
    public earlyAccessInfo : IEarlyAccessInfo;
    public earlyAccessLoaded : boolean = false;

    private earlyAccessParams = () => {
        return {
            method: "user.getLoyaltyEarlyAccessInfo",
            params: [
                {
                    method: 'get',
                    _TOKEN: this.csrfToken
                }
            ]
        };
    };

    public getEarlyAccessInfo = async () => {
        const { method, params } = this.earlyAccessParams();

        const body = this.formatToRPC(method, params);

        const earlyAccessApiResponse = (await this.fetch({
            method,
            body,
            methodType: METHOD_TYPE
        })) as unknown as IResponse<IPGResponse[]>;

        const earlyAccessResponse: IPGResponse = (earlyAccessApiResponse?.data || [])[0] || [];

        this.isSignedIn = earlyAccessResponse?.result?.value?.signed_in ?? 0;
        this.isLoyaltyMember = earlyAccessResponse?.result?.value?.loyalty_member ?? 0;
        this.earlyAccessSkuIds = earlyAccessResponse?.result?.value?.sku_ids ?? [];

        this.setEarlyAccessInfo(this.isSignedIn, this.isLoyaltyMember, this.earlyAccessSkuIds);

        return this.earlyAccessInfo;
    };

    public setEarlyAccessInfo = (signedIn: number, isLoyaltyMember: number, earlyAccessSkuIds: number[]) => {
            this.earlyAccessLoaded = true;
            this.earlyAccessInfo = {
                "isSignedIn": signedIn,
                "isLoyaltyMember": isLoyaltyMember,
                "earlyAccessSkuIds": earlyAccessSkuIds
            } as IEarlyAccessInfo;
    }
}
